import { usePaymentApi } from 'api/payment/use-payment-api';
import * as networkSelectors from 'app/state/network/network-selectors';
import { ZERO as NO_AUTO_DISMISS } from 'common/constants';
import template from 'lodash/template';
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'rsuite';
import { captureExceptionWithContext } from 'utils/sentry-functions';
import { parseHTMLString } from 'utils/utility-functions';
import { PaymentButton } from '../../modules/payment-button/payment-button';

const savePayerDetails = async ({ email, onSuccess, paymentId, signatory, payCheck }) => {
  await payCheck({ email, paymentId, signatory });
  await onSuccess();
};

const label = 'Select Check as your payment method';

export const DEFAULT_PAY_BY_CHECK_TEXT = `
<div>
  Please click the button below to confirm that you wish to pay by check.
</div>
`;

export const Check = ({ signatory, email, onSuccess, paymentTabPayByCheckText = DEFAULT_PAY_BY_CHECK_TEXT }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { payCheck } = usePaymentApi();

  const { paymentId } = useSelector(networkSelectors.paymentFees);
  const isPaymentFeesReady = useSelector(networkSelectors.isPaymentFeesReady);

  const templatedMessage = useMemo(() => {
    // const checkDetailsInit = {
    //   checkContactEmail: undefined,
    //   checkMailingAddress: undefined,
    //   checkUniqueCode: undefined,
    //   id: undefined,
    //   paymentId: undefined,
    //   checkTotal: undefined,
    // };

    // const checkDetailsUpdated = {
    //   ...checkDetailsInit,
    //   ...checkDetails,
    //   checkTotal: convertNumberToCurrency(paymentFees.checkTotal)
    // };

    return template(paymentTabPayByCheckText)({});
  }, [paymentTabPayByCheckText]);

  const handleClick = useCallback(async () => {
    setIsLoading(true);
    try {
      await savePayerDetails({ paymentId, signatory, email, onSuccess, payCheck });
    } catch (err) {
      captureExceptionWithContext(err, { paymentId });
      Alert.error('An error has occurred while attempting to initiate the payment. Please try again at a later time.', NO_AUTO_DISMISS);
    } finally {
      setIsLoading(false);
    }
  }, [email, onSuccess, payCheck, paymentId, signatory]);

  return (
    <div>
      {paymentTabPayByCheckText && parseHTMLString(templatedMessage)}
      <PaymentButton disabled={!isPaymentFeesReady} label={label} loading={isLoading} onClick={handleClick} />
    </div>
  );
};
